import React, { useState } from 'react';
import { IAssignDishToSubcategoriesValidateMetadata, IItemForGetShortInfo } from 'types';
import Text from 'components/Text/Text';
import breadcrumbs from 'images/breadcrumbs.svg';
import { ItemList } from 'components/ViewPage//ItemList';
import classNames from 'classnames';
import style from './ValidationInfo.module.scss';

interface IProps {
	validationInfo: IAssignDishToSubcategoriesValidateMetadata;
	fetchedRestaurants: IItemForGetShortInfo[];
	selectedRestaurants: string[];
}

export const ValidationInfo: React.FC<IProps> = React.memo(
	({ validationInfo, fetchedRestaurants, selectedRestaurants }) => {
		const [isVisibleCategory, setIsVisibleCategory] = useState(true);
		const [isVisibleSubcategory, setIsVisibleSubcategory] = useState(true);
		const closeCategoryIconClasses = classNames(style.icon, {
			[style.rotate]: !isVisibleCategory,
		});
		const closeSubcategoryIconClasses = classNames(style.icon, {
			[style.rotate]: !isVisibleSubcategory,
		});

		const subcategoryRestaurantsMap = new Map<string, IItemForGetShortInfo>();
		validationInfo.subCategories.forEach((item) => {
			item.restaurants.forEach((restaurant: IItemForGetShortInfo) => {
				subcategoryRestaurantsMap.set(restaurant.id, restaurant);
			});
		});
		const notAvailableSubcategoryRestaurants: IItemForGetShortInfo[] = Array.from(
			subcategoryRestaurantsMap.values(),
		);

		const categoryRestaurantsMap = new Map<string, IItemForGetShortInfo>();
		validationInfo.categories.forEach((item) => {
			item.restaurants.forEach((restaurant: IItemForGetShortInfo) => {
				categoryRestaurantsMap.set(restaurant.id, restaurant);
			});
		});
		const notAvailableCategoryRestaurants: IItemForGetShortInfo[] = Array.from(categoryRestaurantsMap.values());

		const notAvailableRestaurantIDs = [
			...notAvailableSubcategoryRestaurants,
			...notAvailableCategoryRestaurants,
		].map((restaurant) => restaurant.id);
		const selectedRestaurantsShortInfo = fetchedRestaurants.filter((restaurant) =>
			selectedRestaurants.includes(restaurant.id),
		);
		const availableRestaurant = selectedRestaurantsShortInfo.filter(
			(restaurant) => !notAvailableRestaurantIDs.includes(restaurant.id),
		);

		return (
			<div className={style.container}>
				<div className={style.availableRestaurants}>
					<Text translationKey="availableRestaurants" translationNameSpace="modals" size="m" weight="bold" />
					<Text translationKey="descriptionForAvailableRestaurants" translationNameSpace="modals" size="s" />
					<ItemList items={availableRestaurant} />
				</div>

				<div className={style.notAvailableRestaurants}>
					<div className={style.headingOfBlock}>
						<Text
							translationKey="notAvailableCategory"
							translationNameSpace="modals"
							size="s"
							weight="bold"
						/>
						<div className={style.btn} onClick={() => setIsVisibleCategory(!isVisibleCategory)}>
							<svg className={closeCategoryIconClasses}>
								<use xlinkHref={`${breadcrumbs}#closeInfo`} />
							</svg>
						</div>
					</div>
					{isVisibleCategory && (
						<div className={style.listWrapper}>
							<ItemList items={notAvailableCategoryRestaurants} />
						</div>
					)}
				</div>

				<div className={style.notAvailableRestaurants}>
					<div className={style.headingOfBlock}>
						<Text
							translationKey="notAvailableSubcategory"
							translationNameSpace="modals"
							size="s"
							weight="bold"
						/>
						<div className={style.btn} onClick={() => setIsVisibleSubcategory(!isVisibleSubcategory)}>
							<svg className={closeSubcategoryIconClasses}>
								<use xlinkHref={`${breadcrumbs}#closeInfo`} />
							</svg>
						</div>
					</div>
					{isVisibleSubcategory && (
						<div className={style.listWrapper}>
							<ItemList items={notAvailableSubcategoryRestaurants} />
						</div>
					)}
				</div>
			</div>
		);
	},
);
